module.exports = __webpack_public_path__ + "8273a566852db59da6ebfed2a85ef3d3.svg";